var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-text',[_vm._v(" ERLEDIGTE AUFTRÄGE (NICHT ABGERECHNET) - TOP 4 ")]),(_vm.renderComponent)?_c('cPie',{attrs:{"height":300,"chartData":_vm.chartData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }